import { compose, setPropTypes, mapProps } from 'recompose';
import InvitationExpired from 'components/Error/InvitationExpired';
import withAnalyticsPageView from 'data/tracking/withAnalyticsPageView';
import withErrorPageView, {
  WithErrorPageViewPropType,
} from 'data/tracking/withErrorPageView';
import { withPlan } from 'data/plan/withPlan';

export default compose<any, typeof InvitationExpired>(
  withPlan,
  mapProps((props: any) => ({
    error: props.error,
    theme: props.themes.light,
  })),
  setPropTypes({
    ...WithErrorPageViewPropType,
  }),
  withAnalyticsPageView('/error/invite-has-expired/'),
  withErrorPageView('invite_has_expired'),
)(InvitationExpired);
